import axios from "axios";
import { environment } from "../config/environment";

export const getProducerBySlug = async (slug) => {
  return await axios.get(`${environment.auth}/${slug}`);
};
